import { render } from "./ExportRRIM_Document.vue?vue&type=template&id=6a735da1"
import script from "./ExportRRIM_Document.vue?vue&type=script&lang=js"
export * from "./ExportRRIM_Document.vue?vue&type=script&lang=js"

import "./ExportRRIM_Document.vue?vue&type=style&index=0&id=6a735da1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__